import {baseKeysUseQuery} from '#/hooks/query/base/base-keys-use-query';
import {shouldWaitlistNetDisplayNullUserAssets} from '#/utils/should-waitlist-net-display-null-user-assets';
import {wagmiConfig} from '#/wagmi/wagmi-config';
import {Hex, Land, ShareLandMarket__factory, accountInfoToLandAccountInfo} from '@shareland/shareland-common';
import {useQueries} from '@tanstack/react-query';
import {readContract} from 'wagmi/actions';

export const useLandAccountInfo = (land: Land | undefined, account: Hex | undefined) => {
  const {
    data: [landAccountInfo],
    isLoading,
    error,
  } = useLandAccountInfos(land ? [land] : [], account);

  return {
    data: landAccountInfo,
    isLoading,
    error,
  };
};

export const useLandAccountInfos = (lands: Land[], account: Hex | undefined) => {
  const queryResult = useQueries({
    queries: lands.map(land => ({
      queryKey: [baseKeysUseQuery.useLandAccountInfo, account, land.id],
      queryFn: async () => {
        if (shouldWaitlistNetDisplayNullUserAssets(account!)) {
          return accountInfoToLandAccountInfo({
            landTokenAmount: 0n,
            landTokenMarketValue: 0n,
            borrowedLandTokenAmount: 0n,
            stableTokenInCollateralAmount: 0n,
            collateralRatio: 0n,
            lpTokenAmount: 0n,
            claimableStableToken: 0n,
          });
        }

        const accountInfo = await readContract(wagmiConfig, {
          address: land!.contractAddresses.market,
          abi: ShareLandMarket__factory.abi,
          functionName: 'getAccountInfo',
          args: [account!],
        } as const);

        return accountInfoToLandAccountInfo(accountInfo);
      },
      enabled: !!account,
    })),
  });

  return {
    data: queryResult.map(result => result.data),
    isLoading: queryResult.some(result => result.isLoading),
    error: queryResult.find(result => result.error)?.error,
  };
};
